var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPython(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 106,
    viewBox: "0 0 125 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0652 51.0513C14.1441 55.1231 18.3102 70.2604 19.3067 75.7908C22.0507 91.0193 17.7453 70.24 17.7347 76.9659",
    stroke: "#2F7578",
    strokeOpacity: 1,
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75357 57.6344C5.38556 51.4381 3.99559 42.8381 12.6841 43.7235C16.7716 44.14 21.2743 46.5663 23.8225 49.8122C27.7604 54.8283 25.6829 62.6036 21.4277 66.5958C19.1634 68.7203 16.9664 69.7847 14.0025 70.588C8.98193 71.9487 12.9442 64.9757 13.7527 63.064",
    stroke: "#2F7578",
    strokeOpacity: 1,
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3519 65.2067C36.985 64.7451 44.9314 63.0456 48.0196 72.408C49.8144 77.8491 52 84.4596 50.5038 90.1937C49.1518 95.3748 46.2403 98.6139 40.9161 96.4068C33.3081 93.2529 33.3184 87.3148 37.4593 81.3934C38.984 79.2132 44.8232 74.8474 44.8272 72.2983",
    stroke: "#2F7578",
    strokeOpacity: 1,
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.912 55.1037C43.6175 57.3751 43.6129 73.4436 39.264 73.5978C38.4485 73.6267 37.7636 74.0509 37.0515 74.4056C34.3135 75.7692 35.9789 74.5423 37.0011 73.1232C39.3162 69.9094 44.0055 71.0967 46.3534 66.8313C48.9029 62.1994 50.0774 59.921 46.4223 56.3376C43.8606 53.8263 44.986 49.5546 42.9692 55.5733",
    stroke: "#2F7578",
    strokeOpacity: 1,
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6532 40.5217C59.9898 48.0332 63.0392 57.8154 68.3916 64.3539C69.8061 66.0818 70.6 64.5778 70.5785 63.2321C70.5513 61.5315 70.0715 59.8161 69.5789 58.2061",
    stroke: "#2F7578",
    strokeOpacity: 1,
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.966 60.0546C52.2598 57.9718 65.2581 55.8637 67.4733 49.253",
    stroke: "#2F7578",
    strokeOpacity: 1,
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2474 40.7676C86.1925 80.902 63.8377 52.6935 75.5004 45.3534C82.5796 40.8979 83.1703 61.8973 85.1318 52.8137",
    stroke: "#2F7578",
    strokeOpacity: 1,
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7399 39.3868C84.5723 41.8761 87.3682 58.307 93.1891 54.5536C95.7918 52.8753 98.8235 49.6752 99.3253 46.5294C99.8638 43.1538 97.7552 34.579 92.9837 35.5022C90.8061 35.9236 87.1644 36.0254 85.7439 38.0946C84.3706 40.0949 83.5039 44.7792 85.1523 39.8601",
    stroke: "#2F7578",
    strokeOpacity: 1,
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9971 35.4086C106.504 31.2312 114.152 29.8595 115.142 39.6981C115.266 40.9327 115.289 42.4879 115.856 43.6245C116.512 44.9427 115.163 40.4026 113.886 39.6699",
    stroke: "#2F7578",
    strokeOpacity: 1,
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M99.52 39.1762C99.8144 44.3191 99.0793 51.2859 101.482 56.1106C101.564 56.2754 102.135 57.5339 101.847 56.8439C101.278 55.4793 101.042 54.5526 99.9691 53.0726",
    stroke: "#2F7578",
    strokeOpacity: 1,
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPython);
export default __webpack_public_path__ + "static/media/python.27d49aaac18227933712f2c027a2004c.svg";
export { ForwardRef as ReactComponent };